import React, { useState } from 'react';
import { Marker, Layer, Source } from 'react-map-gl';
import uuid from 'uuid';
import { Icons } from '../../..';
// constants
import { prefix } from '../../../../constants';
const CloseButton = ({ handleClose }) => {
    return (React.createElement("button", { className: "mapboxgl-popup-close-button", onClick: e => handleClose(e) },
        React.createElement(Icons, { iconName: "ic-ui-cancel-sm" })));
};
const AnchorLayer = ({ uniqueId, anchorLngLat, popupLngLat, }) => {
    const anchorSourceData = {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: [
                        [anchorLngLat.lng, anchorLngLat.lat],
                        [popupLngLat.lng, popupLngLat.lat],
                    ],
                },
                properties: null,
            },
        ],
    };
    return (React.createElement(Source, { id: `${uniqueId}AnchorSource`, type: "geojson", data: anchorSourceData },
        React.createElement(Layer, { id: `${uniqueId}AnchorLayer`, type: "line", paint: {
                'line-color': '#8897a2',
            } })));
};
export const MapPopupMoveable = ({ longitude, latitude, anchorLongitude = longitude, anchorLatitude = latitude, anchorLine = true, closeButton = true, onClose, canBeClosed = true, children, className = '', offsetLeft = 0, offsetTop = 0, draggable = true, }) => {
    const [popupLngLat, setPopupLngLat] = useState({
        lng: longitude,
        lat: latitude,
    });
    const [isDragActive, setIsDragActive] = useState(false);
    const [isClosed, setIsClosed] = useState(false);
    const [hasMoved, setHasMoved] = useState(false);
    const [isMouseDown, setIsMouseDown] = useState(false);
    const [uniqueId] = useState(uuid.v4());
    // When drag is finished, update lat longs for the drawn line
    const dragEndHandle = e => {
        e.preventDefault();
        const { lngLat } = e;
        setPopupLngLat({ lng: lngLat[0], lat: lngLat[1] });
        setIsDragActive(false);
    };
    // Remove the anchor line while dragging
    const dragStartHandle = e => {
        e.preventDefault();
        setHasMoved(true);
        setIsDragActive(true);
    };
    // Close button controls + event passback
    const handleClose = e => {
        e.preventDefault();
        if (onClose) {
            onClose();
        }
        if (canBeClosed) {
            setIsClosed(true);
        }
    };
    const circleSourceData = {
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [anchorLongitude, anchorLatitude],
        },
        properties: null,
    };
    return (React.createElement(React.Fragment, null, !isClosed ? (React.createElement(React.Fragment, null,
        React.createElement(Marker, { longitude: popupLngLat.lng, latitude: popupLngLat.lat, className: `${className} ${prefix}-map-popup ${prefix}-map-popup-moveable`, draggable: draggable, onDragStart: e => dragStartHandle(e), onDragEnd: e => dragEndHandle(e), offsetLeft: !hasMoved ? offsetLeft : undefined, offsetTop: !hasMoved ? offsetTop : undefined },
            React.createElement("div", { className: "mapboxgl-popup mapboxgl-popup-anchor-bottom mosaic-map-popup", style: { cursor: isMouseDown ? 'grabbing' : 'grab' }, onMouseDown: e => setIsMouseDown(true), onMouseUp: e => setIsMouseDown(false) },
                React.createElement("div", { className: "mapboxgl-popup-content" },
                    closeButton && React.createElement(CloseButton, { handleClose: handleClose }),
                    children))),
        !isDragActive && anchorLine && (React.createElement(React.Fragment, null,
            React.createElement(AnchorLayer, { uniqueId: uniqueId, anchorLngLat: { lng: anchorLongitude, lat: anchorLatitude }, popupLngLat: popupLngLat }),
            React.createElement(Source, { id: `${uniqueId}CircleSource`, type: "geojson", data: circleSourceData },
                React.createElement(Layer, { id: `${uniqueId}anchorLayer`, type: "circle", paint: {
                        'circle-radius': 4,
                        'circle-color': 'white',
                        'circle-stroke-color': '#0b6bf2',
                        'circle-stroke-width': 2,
                        'circle-opacity': 1,
                    } })))))) : null));
};
//# sourceMappingURL=MapPopupMoveable.js.map